// extracted by mini-css-extract-plugin
module.exports = {"sidenote":"Sidenote-module--sidenote--3Iuu9","title":"Sidenote-module--title--29GDl"};